var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48084 1H11.3202L7.28157 5.6679L12 12H8.29723L5.3982 8.15203L2.07931 12H0.23992L4.51849 7.00738L0 1H3.79473L6.41386 4.51513L9.48084 1ZM8.83705 10.9041H9.85671L3.25891 2.05535H2.16328L8.83705 10.9041Z",
    fill: "rgba(0, 0, 0, 0.54)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fcc8e518577aefbce98575c9023f22fc.svg";
export { ForwardRef as ReactComponent };